<template>
    <div class="breadcrumb-container">
        <img class="img-home" src="@/assets/icon/ic-home-bc.svg" alt="">
        <span v-if="searchList" class="route-page" @click="clickRoute('/')">{{ lbl.page.home }}</span>
        <span v-else class="route-page" @click="clickRoute('/')">Home</span>
        <span class="text-gray">/</span>

        <template v-if="searchList">
            <span v-if="searchList" :class="subPageName ? 'route-page' : 'active' " @click="clickRoute()">{{lbl.page.search}}</span>
            <span v-else :class="subPageName ? 'route-page' : 'active' " @click="clickRoute()">{{pageName}}</span>
            <span v-if="subPageName" class="text-gray">/</span>
        </template>
        <template v-else-if="isCampaign">
            <template v-if="isFlashSale">
                <span class="route-page" @click="clickRoute('/flashsale')">Flash Sale</span>
                <span class="text-gray">/</span>
            </template>
            <span :class="'active'" @click="clickRoute()">{{subPageName}}</span>
        </template>
        <template v-else>
            <span class="route-page" @click="clickRoute('/main/myprofile')">My Account</span>
            <span class="text-gray">/</span>
            <span :class="subPageName ? 'route-page' : 'active' " @click="clickRoute()">{{pageName}}</span>
            <span v-if="subPageName" class="text-gray">/</span>
            <span class="active" v-if="subPageName">{{subPageName}}</span>
        </template>
    </div>
</template>

<script>
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'Breadcrumb',
    mixins: [LocaleMixin],
    props: {
        pageName: { type: String, required: true },
        subPageName: { type: String, default: null },
        searchList: { type: Boolean, default: false },
        isCampaign: { type: Boolean, default: false },
        isFlashSale: { type: Boolean, default: false },
    },
    mounted: function () {
    },
    methods: {
        clickRoute: function (path) {
            if (this.$route.path.indexOf('privacysetting') > -1 && this.subPageName) {
                this.$router.push('/main/privacysetting')
                this.$emit('updateSubPageName')
                return;
            }else if(path) {
                this.$router.push(path)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    @import "./Breadcrumb.scss";
</style>
